// Centralized copy + enums for the AI Response generation experience (EAI-1497).
// Keeping user-facing strings here makes the terminology rename auditable and
// prevents the "Suggest Message" / "Customize AI Suggestion" copy from drifting
// back across the three composer surfaces (SMS / reviews / email).

export const AI_RESPONSE_COPY = {
  GENERATE: "Generate Response",
  CUSTOMIZE_TITLE: "Customize AI response",
  GENERATE_TOOLTIP: "Generate Response",
  CUSTOMIZE_TOOLTIP: "Customize AI response",
  MAXIMIZE: "Maximize",
  MINIMIZE: "Minimize",
  MY_PREFERENCES_TITLE: "My Preferences",
  MY_PREFERENCES_BANNER:
    "Preferences apply automatically every time you use Generate Response, and pre-fill the Customize AI Response popup.",
  HIDE_UNHIDE_TITLE: "Hide/Unhide tips and tones",
  HIDE_UNHIDE_LINK: "Hide/unhide",
  SAVE: "Save",
  BACK: "Back",
  MANAGE_CUSTOM_TITLE: "Manage my custom tips & tones",
  ALWAYS_INCLUDE: "Always include",
  DEFAULT_TONE: "Default tone",
  SAVE_PREFERENCES: "Save Preferences",
  ADD_TIP: "Add tip",
  ADD_TONE: "Add tone",
  QUICK_TIPS: "Tips",
  TONES: "Tones",
  ADDITIONAL_NOTES: "Instructions for AI",
  ADDITIONAL_NOTES_OPTIONAL: "Instructions for AI (optional)",
  ADDITIONAL_NOTES_MARK: "(optional)",
  ADDITIONAL_NOTES_TOOLTIP:
    "Tell AI anything specific you want in this message. An offer, a deadline, a detail, or a tone shift. AI blends it into the reply along with the tips and tone you picked.",
  ADDITIONAL_NOTES_PLACEHOLDER:
    "e.g. Ask if they're free to come in this Saturday for a test drive",
  REPLY_AS: "Reply as",
  REPLY_AS_SELF: "Myself",
  NO_TIPS: "No Quick Tips found",
  NO_TONES: "No Tones found",
  // "Save these preferences" checkbox (EAI-1497 final design) — persists the
  // current selection as the user's default (preserved) for this location.
  SAVE_PREFERENCES_FUTURE: "Save these preferences for future responses",
  SAVE_PREFERENCES_TOOLTIP:
    "Applies these tips and tone to every new message across all leads until you change them. Your instructions for AI aren't saved.",
  SAVED_TOAST: "Saved as your default for future responses.",
  // Add/Edit custom tip/tone form (CustomItemForm).
  CUSTOM_WHERE_USED: "Where should this {noun} be used?",
  CHANNEL_TEXT: "Text",
  CHANNEL_TEXT_HELP: "While drafting the text response.",
  CHANNEL_EMAIL: "Email",
  CHANNEL_EMAIL_HELP: "While drafting the email response.",
  CUSTOM_INSTRUCTIONS_HELP:
    "The instructions AI follows when applying this quick {noun}. Describe what you want AI to do so it can draft responses that match your intent.",
  // Per-item actions menu (own custom tips/tones only).
  MENU_EDIT: "Edit",
  MENU_DELETE: "Delete",
  CANCEL: "Cancel",
  DELETE_CONFIRM_TITLE: "Delete this {noun}?",
  // {Noun} = capitalized singular (Tip/Tone), {noun}s = lowercase plural.
  DELETE_CONFIRM_BODY:
    "This {noun} will be permanently removed from your {noun}s list. This action can’t be undone.",
};

// communicationChannels values sent to the backend for a custom tip/tone.
// Keyed by the CustomItemForm channel toggles (`text` / `email`).
export const COMMUNICATION_CHANNEL = {
  TEXT: "Text",
  EMAIL: "Email",
};

// suggestionType discriminator shared with the admin config
// (mirrors ADDING_TYPE in adminDashboard/settings/CustomizeAiSuggestions).
export const SUGGESTION_TYPE = {
  TIPS: "QUICK_TIPS",
  TONES: "QUICK_TONES",
  ADDITIONAL_NOTES: "ADDITIONAL_NOTES",
};
